import { Component, EventEmitter, Output, Input } from '@angular/core';
import { NoteUpd } from '../../shared/models/NoteUpd';
import { ConfirmOutput } from '../../shared/models/ConfirmOutput';
import { CPDialogResult } from '../../shared/enums/CPDialogResult';
import { CRUDActions } from '../../shared/enums/CRUDActions';
import { CommonFunctions } from '../../shared/static/common-functions';
import { BaseMessageInfo } from '../../shared/models/BaseMessageInfo';
import { MessageInfo } from '../../shared/models/MessageInfo';
import { GlobalsService } from '../../shared/services/globals.service';
import { DispatchAssignmentBus } from '@app/cp/shared/models/DispatchAssignmentBus';
import { DispatchesService } from '@app/cp/shared/services/dispatches.service';
import { v_DispatchAssignmentBus } from '@app/cp/shared/models/v_DispatchAssignmentBus';
import { DQOIReferenceData } from '@app/cp/shared/models/DQOIReferenceData';
import { BaseDQOIComponent } from '@app/cp/shared/base-components/base-dqoi.component';
import { GItem } from '../../shared/models/GItem';
import { DispatchPartsBus } from '../../shared/models/DispatchPartsBus';
import { DropDownFilterSettings } from '@progress/kendo-angular-dropdowns';
import { DispatchLaborBus } from '../../shared/models/DispatchLaborBus';
import { DateFunctions } from '../../shared/static/date-functions';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";
@Component({
    selector: 'dispatch-qv-labor-add-dialog',
    templateUrl: './dispatch-qv-labor-add-dialog.component.html',
    styleUrls: ['./dispatch-qv-labor-add-dialog.component.scss']
})
export class DispatchQvLaborAddDialogComponent  {
    public featureFlagSet: any = {};

    public static virtualizationSettings = { itemHeight: 30, pageSize: 100 };

    constructor(globals: GlobalsService, private svc_data: DispatchesService, protected featureFlagService: FeatureFlagService) {

        this.featureFlagService.featureFlagSets.subscribe(data => {
            this.featureFlagSet = data;
        });
    }
    get referenceData(): DQOIReferenceData {
        return BaseDQOIComponent._referenceData;
    }
    maxEndDate: Date;
    minEndDate: Date;
    //data
    personId: any;
    laborTypeId: any;
    timeTypeId: any;
    nonPaid: boolean;
    personName: string;
    startDate: Date;
    endDate: Date;
    active: boolean = false;
    data: any;
    gridData: v_DispatchAssignmentBus[];
    action: CRUDActions;
    techId: string;
    assignmentDateTime: Date;
    code: string;
    @Input() title: string;
    @Input() message: string;
    @Output() confirmation: EventEmitter<ConfirmOutput> = new EventEmitter<ConfirmOutput>();
    @Input() sublings: GItem[] =[];
    truckList: GItem[] = []
    hide() {
        this.active = false;
        this.data = null;
        this.title = null;
        this.message = null;
        this.action = CRUDActions.None;

    }
    ok() {
        let result: ConfirmOutput = {
            action: this.action, dialogResult: CPDialogResult.ok, data: { techId: this.techId, assignmentDateTime: this.assignmentDateTime}, code: this.code }
        this.confirmation.emit(result);
        this.hide();
    }
    cancel() {
        let result: ConfirmOutput = { action: this.action, dialogResult: CPDialogResult.cancel, data: null, code: this.code }
        this.confirmation.emit(result);
        this.hide();
    }
    close() {
        let result: ConfirmOutput = { action: this.action, dialogResult: CPDialogResult.close, data: null, code: this.code }
        this.confirmation.emit(result);
        this.hide();
    }
    public show(list: GItem[]) {

        this.active = true;
        this.personId = null;
        this.laborTypeId = null;
        this.timeTypeId = null;
        this.nonPaid = null;
        this.personName = null;
        this.startDate = null;
        this.endDate = null;

        this.minEndDate = null;
        this.maxEndDate = null;

    }

    public getNewPart() {

        let dispatchLaborBus: DispatchLaborBus = new DispatchLaborBus();

        //var selecttruck = this.truckList.find(ev => ev.value === this.inventoryLocationId)
        //if (selecttruck) {

        //    dispatchLaborBus.personId = selecttruck.category;

        //}

        dispatchLaborBus.dispatchLaborId = '00000000-0000-0000-0000-000000000000';
        //     dispatchPartsBus.dispatchId =
        //dispatchPartsBus.inventoryLocationXrefid = this.inventoryLocationXrefid;
        //dispatchPartsBus.inventoryLocationId = this.inventoryLocationId;
        //dispatchPartsBus.inventoryId = this.partId;
        //dispatchPartsBus.quantity = this.partQuantity;

        dispatchLaborBus.personId = this.personId;
        dispatchLaborBus.timeTypeId = this.timeTypeId;
        dispatchLaborBus.laborTypeId = this.laborTypeId;
        dispatchLaborBus.nonPaid = this.nonPaid;

        dispatchLaborBus.startDate = DateFunctions.getDateTimeWithUTCOffset(this.startDate);
        dispatchLaborBus.endDate = DateFunctions.getDateTimeWithUTCOffset(this.endDate);

        dispatchLaborBus.calculateHours();
        dispatchLaborBus.insertDt = new Date(Date.now());
        dispatchLaborBus.updateDt = new Date(Date.now());

        return dispatchLaborBus;

    }
    genericCloseCtrl(e: any) {
        if (!this.endDate)
        {
            this.endDate = this.startDate;
        }
        if (this.endDate < this.startDate) {
            this.endDate = this.startDate;
        }
        this.minEndDate = new Date(this.startDate);
        this.maxEndDate = DateFunctions.addDays(this.minEndDate, 1);
        if (!DateFunctions.hasReasonableDateValue(this.endDate)) {
            this.endDate = this.minEndDate;
        }

    }
    overlap = null;
    private async validateDispatchLaborOverLap(): Promise<boolean> {

        if (this.featureFlagSet['prevent-duplicate-time-entries-from-being-entered']) {
            if (this.personId && this.endDate && this.startDate) {
                //var startDate = DateFunctions.getDateTimeWithUTCOffset(this.editForm.value.startDate);
                //var endDate = DateFunctions.getDateTimeWithUTCOffset(this.editForm.value.endDate);
                //var startDate = this.startDate;
                //var endDate = this.endDate;
                //var personId = this.personId;
                //     this.overlap = null;
                //var changed = this.gridData.filter(a => a.isUpdated).map(a => a.dispatchLaborId);
                //if (this.editForm && this.editForm.value && this.editForm.value.dispatchLaborId) {
                //    changed.push(this.editForm.value.dispatchLaborId);
                //}
                var busObj =
                {
                    startDate: DateFunctions.getDateTimeWithUTCOffset(this.startDate),
                    endDate: DateFunctions.getDateTimeWithUTCOffset(this.endDate),
                    personId: this.personId,
                    dispatchLaborIdsToSkip: []
                }

                await this.svc_data.validateDispatchLaborOverLap(busObj).toPromise().then((data: any) => {
                    if (data.laborOverlap) {
                        this.overlap = {
                            startDate: data.overlaps[0].startDate,
                            endDate: data.overlaps[0].endDate,
                            dispatchNumber: data.overlaps[0].dispatchNumber
                        }
                    }
                    else {
                        this.overlap = null;
                    }
                })

            }
            if (this.overlap) {
                return false;
            }
        } else { this.overlap = null; }
        return true;
    }

    public canSave() {

        if (!this.personId ||
            !this.timeTypeId ||
            !this.laborTypeId ||
            !this.startDate ||
            !this.endDate ||
            this.startDate > this.endDate
        ) return false;
        if (this.overlap) {
            return false;
        }
        return true;
    }
    public filterSettings: DropDownFilterSettings = {
        caseSensitive: false,
        operator: 'contains'
    };
}

